export const CONTACT = {
  addressLine1: "20, Periyarasingan North Street",
  addressLine2: "Vadasery, Nagercoil",
  addressLine3: "Kanyakumari, Tamil Nadu - 629001",
  phone: "04652-462819",
  phoneHref: "tel:+914652462819",
  email: "info@hbtintegrisys.com",
  careersEmail: "hr@hbtintegrisys.com",
  // Must match the Google Business Profile and the openingHoursSpecification
  // in index.html's JSON-LD.
  hours: "Mon – Fri, 10:00 AM – 8:00 PM",
};

// LinkedIn and Instagram are also listed as "sameAs" in index.html's
// JSON-LD; keep the two in sync.
export const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/hbtintegrisys",
  instagram: "https://www.instagram.com/hbtintegrisys",
  // wa.me takes the number in international format without "+".
  whatsapp: "https://wa.me/918778914732",
};

// Google Form for internship applications only. Other roles apply by email
// to careersEmail.
export const INTERNSHIP_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSeg9os3vFxCf7khHXMH75RRa4cSqJV-nNKuUSm7tm6HgX0EGQ/viewform";

export const FULL_ADDRESS = `${CONTACT.addressLine1}, ${CONTACT.addressLine2}, ${CONTACT.addressLine3}`;

// Exact office location (from a pin dropped on Google Maps), used instead of
// an address-text lookup so the marker lands precisely on the building.
export const COORDINATES = { lat: 8.193417, lng: 77.431364 };

// Google Maps embed (no API key required) centered on the exact coordinates.
export const MAP_EMBED_SRC = `https://www.google.com/maps?q=${COORDINATES.lat},${COORDINATES.lng}&z=18&output=embed`;

export const MAP_LINK_SRC = `https://www.google.com/maps/search/?api=1&query=${COORDINATES.lat},${COORDINATES.lng}`;
